import React from 'react'

export default function ReauthCompletePage() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="max-w-md rounded-lg border bg-card p-6 text-center text-card-foreground shadow">
        <p className="text-sm text-muted-foreground">Mindennel végeztünk, bezárhatod az ablakot.</p>
      </div>
    </div>
  )
}
